import { setDemoAccountModuleViewed } from '../../../shared/utils/demo-account-handlers';
import { StorageUtil } from '../../../shared/utils/storage';
import {
  getIsDemoAccount,
  getUserEmail,
} from '../../../shared/utils/user-details';
import { removeProspectTableColumnsFromLocalStorage } from '../../prospect/components/prospect-table/utils/helper';

export const baseUrls = {
  production: 'https://my.saleshandy.com',
  staging: 'https://pyxis.lifeisgoodforlearner.com',
};

export const defaultAgencyObj = {
  showClientName: false,
  isDefault: true,
  showInAppNotification: true,
  showWhatsNew: true,
  showScheduleADemo: true,
  showChatSupport: true,
  showHelp: true,
  showFeatureRequest: true,
  showGettingStarted: true,
  showInfoTips: true,
  showYTVideoGuide: true,
  showFAQ: true,
  showEmailContentGuideHelp: true,
  showEmailContentGuide: true,
  logo: {
    primary:
      'https://v3api.lifeisgoodforlearner.com/image-broker/image/' +
      'eyJpdiI6IjUyOTZlYzA4NmU3NTYzYjdmZmQ4ZmFhYjhmZWY4NDFmIiwiY29udGVudCI6IjU0YjE3N2E3MjZhMzk4ZTJiMmJhYjc3OWVhZDk2ZGZlYzM2' +
      'ZTNkZWU5M2VlOGU0OTg3Y2MwMDA3ZmM0ODI5MWIyZDNjMDg5MmYxODU1NzllZTVlYWNkZWI2MzlkM2U4NTFhYTg4OWYyYTQ4MjM3ZmJkZjlkM2I1ODM2' +
      'MzYzNTIzZDgxODg1MDdmZGE5ZGM1ZWUyNDQ3NzBiMDU3MjY2YTVhYSJ9',
    tertiary:
      'https://v3api.lifeisgoodforlearner.com/image-broker/image/' +
      'eyJpdiI6IjUyOTZlYzA4NmU3NTYzYjdmZmQ4ZmFhYjhmZWY4NDFmIiwiY29udGVudCI6IjU0YjE3N2E3MjZhMzk4ZTJiMmJhYjc3OWVhZDk2ZGZlYzM2' +
      'ZTNkZWU5M2VlOGU0OTg3Y2MwMDA3ZmM0ODI5MWIyZDNjMDg5MmYxODU1NzllZTVlYWNkZWI2MzlkM2U4NTFhYTg4OWYyYTQ4MjM3ZmJkZjlkM2I1ODM2' +
      'MzYzNTIzZDgxODg1MDdmZGE5ZGM1ZWUyNDQ3NzBiMDU3MjY2YTVhYSJ9',
    showAgencyNameWithLogo: true,
    secondary:
      'https://v3api.lifeisgoodforlearner.com/image-broker/image/' +
      'eyJpdiI6IjUyOTZlYzA4NmU3NTYzYjdmZmQ4ZmFhYjhmZWY4NDFmIiwiY29udGVudCI6IjU0YjE3N2E3MjZhMzk4ZTJiMmJhYjc3OWVhZDk2ZGZlYzM2' +
      'ZTNkZWU5M2VlOGU0OTg3Y2MwMDA3ZmM0ODI5MWIyZDNjMDg5MmYxODU1NzllZTVlYWNkZWI2MzlkM2U4NTFhYTg4OWYyYTQ4MjM3ZmJkZjlkM2I1ODM2' +
      'MzYzNTIzZDgxODg1MDdmZGE5ZGM1ZWUyNDQ3NzBiMDU3MjY2YTVhYSJ9',
  },
  baseUrl: process.env.REACT_APP_API_URL,
  createdAt: '2022-06-01T18:24:56.129Z',
  updatedAt: '2023-01-10T04:33:26.276Z',
  __v: 0,
  showAddStepButton: true,
  showColdEmailTips: true,
  showDraftSequence: true,
  agencyName: 'saleshandy',
  colorPalette: {
    sidebarBgColor: '#F3F4F6',
    navItemActiveBgColor: '#374151',
    navItemHoverBgColor: '#1F2937',
    navItemTextColor: '#1F2937',
  },
  showAgencyNameWithLogo: true,
  showNameFieldsInInviteModal: false,
  ltdExpiryDate: '12-20-2022',
  showTermOfServiceAndPrivacyPolicy: true,
  clientName: 'saleshandy',
  closeOnLogout: false,
  isLocallyCached: true,
  favicon: '/favicon-16x16.png',
};

export const getUserEmailFromStore = () => StorageUtil.getItem('userEmail');

export const storeUserEmail = () => {
  const existingUserEmail = getUserEmailFromStore();
  const currentUserEmail = getUserEmail();

  if (existingUserEmail !== currentUserEmail) {
    // Remove Prospect Table Columns
    removeProspectTableColumnsFromLocalStorage();
  }

  StorageUtil.setItem('userEmail', currentUserEmail);
};

export const removeUserEmailFromStore = () =>
  StorageUtil.removeItem('userEmail');

export const handleDemoAccountModuleViewed = (moduleViewed: string) => {
  if (getIsDemoAccount()) {
    setDemoAccountModuleViewed(moduleViewed);
  }
};

const demoAccountEnteredTimestamp = 'demoAccountEnteredTimestamp';

export const setDemoAccountEnteredTimestamp = () => {
  sessionStorage.setItem(demoAccountEnteredTimestamp, new Date().toString());
};

export const getDemoAccountEnteredTimestamp = () => {
  const ts = sessionStorage.getItem(demoAccountEnteredTimestamp);
  if (!ts) return { durationInSeconds: 0 };

  const enteredTime = new Date(ts).getTime();
  const now = Date.now();
  const durationInSeconds = Math.floor((now - enteredTime) / 1000);

  return { durationInSeconds };
};

export const removeDemoAccountEnteredTimestamp = () => {
  sessionStorage.removeItem(demoAccountEnteredTimestamp);
};
